import {LOG_OUT, TIMESHEET, USER_TIMESHEET, CLOCK_OUT_REASONS} from "./ActionTypes";
import DailyAttendanceService from "../services/DailyAttendanceService";
import {getUser} from "../utils/TokenManager";


const logOutSuccess = () => ({type: LOG_OUT});
const attendanceSheet = (timesheet) => ({type: TIMESHEET, timesheet});
const userTimeSheet = (timesheet) => ({type: USER_TIMESHEET, timesheet});
const clockOutReasons = (reasons) => ({type: CLOCK_OUT_REASONS, reasons});


export const getAttendanceSheet = (locationId) => (
    async (dispatch) => {
        try {
            const result = await DailyAttendanceService.getAttendanceSheet(locationId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {

                dispatch(attendanceSheet(result.data.timesheet));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getUserTimeSheet = (userId, workDate) => (
    async (dispatch) => {
        try {
            const result = await DailyAttendanceService.getUserTimeSheet(userId, workDate);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {

                dispatch(userTimeSheet(result.data.timesheet));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const deleteUserTimesheet = (timeSheetId) => (
    async(dispatch) => {
        let result;
        try{
            result = await DailyAttendanceService.deleteUserTimeSheet(timeSheetId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const updateUserTimeSheet = (userId, workDate, timeSheet, needToAdd) => (
    async (dispatch) => {
        try {
            let result;
            console.log(needToAdd);
            if (needToAdd) {
                result = await DailyAttendanceService.saveUserTimeSheet(userId, workDate, timeSheet);
            } else {
                result = await DailyAttendanceService.updateUserTimeSheet(userId, workDate, timeSheet);
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                dispatch(userTimeSheet(result.data.timesheet));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getReasons = (locationId) => (
    async (dispatch) => {
        try {
            const result = await DailyAttendanceService.getReasons(locationId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(clockOutReasons(result.data.reason));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/DailyAttendanceAction.js